import { ICurrency } from "types/payments/Currency";
import { useCurrencies } from "./useCurrencies";

export const useCustomerCurrency = (): ICurrency | null => {
  const { data: currencyData } = useCurrencies();
  if (!currencyData) {
    return null;
  }
  return (
    currencyData.currencies.find(
      currency => currency.id === currencyData.customer_currency,
    ) || null
  );
};
